module.exports = __webpack_public_path__ + "static/media/Menu.ec906534.png";